import React from 'react';
import { Grid, Typography, Link } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoRow from 'components/InfoRow';
import messages from 'containers/ApplicationFormPage/messages';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '660px',
  },
  link: {
    color: '#00C3B4',
  },
  disabled: {
    color: '#B6B8B4',
  },
}));

export default function Section(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { sectionName, title, currency, value, frequency, additionalSinglePremiumAmount, isWap, isIwa, regularPremium, singlePremium, premiumPaymentTerm, additionalSinglePremiumLabel } = props;

  const premiumPaymentTermDesc = (premiumPaymentTerm == 12) ? <FormattedMessage {...messages.paymentTermMonthly} /> :  <FormattedMessage {...messages.paymentTermSingle} />;
  return (
    <>
  <Grid item xs={12}>
    <Typography variant="body1" color="primary">
      {sectionName}
    </Typography>
  </Grid>
  <Grid item xs={12}>
    {(() => {
      if (isWap === true) {
        return (
          <>
            <InfoRow>
              <Grid
                container
                alignItems="center"
                alignContent="center"
                justify="center"
                spacing={2}
              >
                <Grid item>
                  <CheckCircleIcon
                    fontSize="small"
                    style={{
                      color: theme.palette.grey[400],
                    }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="h4" color="inherit">
                    {title}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                  <div>
                    <Typography variant="h4" color="inherit">
                      {`${currency} ${value}`}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </InfoRow>
            <InfoRow>
              <Grid
                container
                alignItems="center"
                alignContent="center"
                justify="center"
                spacing={2}
              >
                <Grid item>
                  <CheckCircleIcon
                    fontSize="small"
                    style={{
                      color: theme.palette.grey[400],
                    }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="h4" color="inherit">
                    {additionalSinglePremiumLabel}
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ textAlign: 'right' }}>
                  <div>
                    <Typography variant="h4" color="inherit">
                      {`${currency} ${additionalSinglePremiumAmount} ${frequency ? ' / ' + frequency : ''}`}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </InfoRow>
          </>
        );
      } else if (isIwa === true) {
        return (
          <>
            <InfoRow>
              <Grid
                container
                alignItems="center"
                alignContent="center"
                justify="center"
                spacing={2}
              >
                <Grid item>
                  <CheckCircleIcon
                    fontSize="small"
                    style={{
                      color: theme.palette.grey[400],
                    }}
                  />
                </Grid>
                <Grid item xs>
                  <Typography variant="h4" color="inherit">
                    {title}
                  </Typography>
                </Grid>
                <Grid item xs={5} style={{ textAlign: "left" }}>
                  <div>
                    <Typography variant="h4" color="inherit">
                      {`${currency} ${singlePremium}`}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </InfoRow>

            <InfoRow>
                <Grid
                  container
                  alignItems="center"
                  alignContent="center"
                  justify="center"
                  spacing={2}
                >
                  <Grid item>
                    <CheckCircleIcon
                      fontSize="small"
                      style={{
                        color: theme.palette.grey[400],
                      }}
                    />
                  </Grid>
                  <Grid item xs>
                    <Typography variant="h4" color="inherit">
                     <FormattedMessage {...messages.premiumPaymentTerm} />
                    </Typography>
                  </Grid>
                  <Grid item xs={5} style={{ textAlign: "left" }}>
                    <div>
                      <Typography variant="h4" color="inherit">
                        {premiumPaymentTermDesc}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
            </InfoRow>
      
            {premiumPaymentTerm == 12 && (
              <InfoRow>
                <Grid
                  container
                  alignItems="center"
                  alignContent="center"
                  justify="center"
                  spacing={2}
                >
                  <Grid item>
                    <CheckCircleIcon
                      fontSize="small"
                      style={{
                        color: theme.palette.grey[400],
                      }}
                    />
                  </Grid>
                  <Grid item xs>
                    <Typography variant="h4" color="inherit">
                        <FormattedMessage {...messages.regularPremAmount} />
                    </Typography>
                  </Grid>
                  <Grid item xs={5} style={{ textAlign: "left" }}>
                    <div>
                      <Typography variant="h4" color="inherit">
                      {`${currency} ${regularPremium}`} per month
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </InfoRow>
            )}
          </>
        );
      } else {
        return (
          <InfoRow>
            <Grid
              container
              alignItems="center"
              alignContent="center"
              justify="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon
                  fontSize="small"
                  style={{
                    color: theme.palette.grey[400],
                  }}
                />
              </Grid>
              <Grid item xs>
                <Typography variant="h4" color="inherit">
                  {title}
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'right' }}>
                <div>
                  <Typography variant="h4" color="inherit">
                    {`${currency} ${value} ${frequency ? '/ ' + frequency : ''}`}
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </InfoRow>
        );
      }
    })()}
  </Grid>
</>

  );
}
